import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import DetailedSpecs from '../components/DetailedSpecs';

class WidgetContainer extends React.Component {
	render() {
		let rootComponent;
		if (this.props.equipment) {
			const { specCategories, specification } = this.props.equipment;
			const {
				prefs: {
					widgetHeading,
					toggleCollapse,
					panelHeadingWeight,
					panelHeadingCase
				},
				widgetInfo
			} = this.props;

			rootComponent = (
				<DetailedSpecs
					specCategories={specCategories}
					specification={specification}
					widgetInfo={widgetInfo}
					widgetHeading={widgetHeading}
					toggleCollapse={toggleCollapse}
					panelHeadingWeight={panelHeadingWeight}
					panelHeadingCase={panelHeadingCase}
				/>
			);
		}
		return rootComponent;
	}
}

WidgetContainer.propTypes = {
	prefs: PropTypes.shape({
		widgetHeading: PropTypes.string,
		toggleCollapse: PropTypes.string,
		panelHeadingWeight: PropTypes.string,
		panelHeadingCase: PropTypes.string
	}).isRequired,
	equipment: PropTypes.shape({
		specCategories: PropTypes.arrayOf(PropTypes.object).isRequired,
		specification: PropTypes.arrayOf(PropTypes.object).isRequired
	}),
	widgetInfo: PropTypes.shape({
		windowId: PropTypes.string.isRequired,
		widgetName: PropTypes.string.isRequired
	}).isRequired
};

WidgetContainer.defaultProps = {
	equipment: {}
};

const mapStateToProps = state => {
	return {
		prefs: state.prefs,
		equipment: state.equipment,
		widgetInfo: state.widgetInfo
	};
};

const mapDispatchToProps = _dispatch => ({});

const Widget = connect(
	mapStateToProps,
	mapDispatchToProps
)(WidgetContainer);

export default Widget;



// WEBPACK FOOTER //
// ./src/containers/Widget.jsx